import React from 'react';
import ActionButton from '~components/atoms/ActionButton';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { TUpdateTransactionStatusReduxParams } from '~types/feat/approval';

import { TransactionStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';
import * as Styles from './_confirmUpdateTransactionStatusModal.module.scss';

const ConfirmUpdateTransactionStatusModal = () => {
    const isOpen = useAppSelector(state => state.approval.modals.confirmUpdateTransactionStatusModalIsOpen);
    const tempUpdateTransactionState = useAppSelector(state => state.approval.tempUpdateTransactionState);
    const isLoading = useAppSelector(state => state.approval.loadings.updateTransactionStatus);
    const error = useAppSelector(state => state.approval.errors.updateTransactionStatus);

    const getStatus = () => {
        switch (tempUpdateTransactionState.status) {
            case (TransactionStatusEnum.Approved): return 'Approve';
            case (TransactionStatusEnum.Rejected): return 'Reject';
            default: return '';
        }
    };

    const dispatch = useAppDispatch();

    const setIsOpen = (open: boolean) => dispatch(combinedActions.approvalSetConfirmUpdateTransactionStatusModalIsOpen(open));
    const updateTransactionStatus = (data: TUpdateTransactionStatusReduxParams) => dispatch(combinedActions.approvalUpdateTransactionStatusAttempt(data));

    const handleSubmitClick = () => {
        updateTransactionStatus(tempUpdateTransactionState);
    };

    const confirmButtonStyles = UtilFunctions.Styles.concatClassNames([
        (getStatus() === 'Approve' ? Styles['confirm-approve'] : ''),
        (getStatus() === 'Reject' ? Styles['confirm-reject'] : ''),
    ]);

    const handleOnModalClose = () => {
        if (error) {
            dispatch(combinedActions.approvalResetUpdateTransactionStatusState());
        }

        setIsOpen(false);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleOnModalClose}
            title={`Confirm ${getStatus()} transaction?`}
        >
            <div className={Styles['button-container']}>
                <ActionButton
                    testId='approval-buySell-confirmModal-cancel-button'
                    label='Cancel'
                    onClick={handleOnModalClose}
                    className={Styles['cancel-button']}
                />

                <ActionButton
                    testId='approval-buySell-confirmModal-approveReject-button'
                    label={getStatus()}
                    onClick={handleSubmitClick}
                    isLoading={isLoading}
                    className={confirmButtonStyles}
                    disabled={isLoading}
                />
            </div>

            {error
                && (
                    <Text
                        testId='approval-buySell-confirmModal-error-text'
                        label={error}
                        isError
                    />
                )
            }
        </Modal>
    );
};

export default ConfirmUpdateTransactionStatusModal;
